import { render, staticRenderFns } from "./resultUser.vue?vue&type=template&id=2dc8995a&scoped=true&"
import script from "./resultUser.vue?vue&type=script&lang=js&"
export * from "./resultUser.vue?vue&type=script&lang=js&"
import style0 from "./resultUser.vue?vue&type=style&index=0&id=2dc8995a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8995a",
  null
  
)

export default component.exports